import { api } from "../../api"

export async function loadPages(): Promise<Page[]> {
    let site = await api<Page[]>("page", {})
    return site.data
}
